import React, { useState, useEffect } from "react";
import QurealCanvasWrapper from "./QurealCanvasWrapper";
import Tweet from "../../linkedin_posts/TweetPost";
import { Button, message, Popconfirm } from "antd";
import { LeftOutlined, RightOutlined, MenuOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import { useDeleteItemMutation } from "../../_actions/app/items";
import { queryClient } from "../../_helpers/query";
import SocialPostingBox from "../../social_media/SocialPostingBox";
import CanvasFeedbackBar from "./CanvasFeedbackBar";
import { useMedia } from "react-use";

function QurealTweetPreview({
    me,
    data,
    closeBtn,
    close_left = false,
    history_id,
    entry_id,
    open_cust,
    setOpenCust,
    platforms,
    close = () => { },
}) {
    const isMobile = useMedia("(max-width: 700px)");
    const [posting, setPosting] = useState(false);
    const [currentTweetIndex, setCurrentTweetIndex] = useState(0);
    const [tweets, setTweets] = useState([]);

    const user_id = me?.id;
    const org_id = me?.selected_org?.id;

    const deleteMutation = useDeleteItemMutation(() => {
        message.success("Entry deleted successfully!");
        queryClient.invalidateQueries(["items", "qdb_calendar_entries"]);
        if (close) close();
    });

    // Parse tweets from data.content
    useEffect(() => {
        if (data?.content) {
            // Handle array format
            if (Array.isArray(data.content)) {
                const parsedTweets = data.content.map((item, index) => ({
                    id: index,
                    content: item.tweet || item.content || item,
                }));
                setTweets(parsedTweets);
            }
            // Handle single object format
            else if (typeof data.content === "object") {
                setTweets([
                    {
                        id: 0,
                        content:
                            data.content.tweet ||
                            data.content.content ||
                            JSON.stringify(data.content),
                    },
                ]);
            }
        }
    }, [data]);

    const handleCopy = () => {
        const currentTweet = tweets[currentTweetIndex];
        if (currentTweet) {
            navigator.clipboard
                .writeText(currentTweet.content)
                .then(() => {
                    console.log("Tweet copied to clipboard");
                    message.success("Tweet copied to clipboard");
                })
                .catch((err) => {
                    console.error("Failed to copy tweet: ", err);
                    message.error("Failed to copy");
                });
        }
    };

    const handlePost = async () => {
        if (!user_id || !org_id) {
            message.error("Missing required user or organization information");
            return;
        }

        const currentTweet = tweets[currentTweetIndex];
        if (!currentTweet) {
            message.error("No tweet selected");
            return;
        }

        setPosting(true);
        // try {
        //     const response = await axios.post(
        //         "http://localhost:8000/social/twitter/post",
        //         {
        //             user_id: user_id,
        //             post_content: currentTweet.content,
        //             org_id: org_id,
        //         }
        //     );

        //     console.log("Post response:", response);
        //     message.success("Successfully posted to X");
        // } catch (error) {
        //     console.error("Failed to post:", error);
        //     message.error("Failed to post to X");
        // } finally {
        //     setPosting(false);
        // }
        message.success("Successfully posted to X");
        setPosting(false);
    };

    const nextTweet = () => {
        if (currentTweetIndex < tweets.length - 1) {
            setCurrentTweetIndex(currentTweetIndex + 1);
        }
    };

    const prevTweet = () => {
        if (currentTweetIndex > 0) {
            setCurrentTweetIndex(currentTweetIndex - 1);
        }
    };

    const goToTweet = (index) => {
        setCurrentTweetIndex(index);
    };

    if (tweets.length === 0) {
        return <div>Loading tweets...</div>;
    }

    return (
        <QurealCanvasWrapper
            title={`Tweet Preview ${tweets.length > 1
                    ? `(${currentTweetIndex + 1}/${tweets.length})`
                    : ""
                }`}
            actions_left={[
                !isMobile && (
                    <Button
                        key="menu-btn"
                        icon={<MenuOutlined />}
                        onClick={() => {
                            if (setOpenCust) setOpenCust(!open_cust);
                        }}
                    ></Button>
                ),
                close_left && closeBtn,
            ]}
            actions={[
                isMobile && (
                    <CanvasFeedbackBar
                        history_id={history_id}
                        entry_id={entry_id}
                        inline={true}
                    />
                ),
                <Button onClick={handleCopy}>Copy</Button>,
                <Button type="primary" onClick={handlePost} loading={posting}>
                    Post
                </Button>,
                !close_left && closeBtn,
            ]}
            header_height={50}
            controlPanel={
                <div style={{ padding: "15px", height: "100%", overflowY: "auto", display: "flex", flexDirection: "column" }}>
                    <div style={{ flex: 1 }}>
                        <SocialPostingBox
                            platforms={platforms}
                            entry_id={entry_id}
                            org_id={org_id}
                        />
                    </div>
                    {entry_id ? <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                        paddingTop: "20px"
                    }}

                    >
                        <Popconfirm
                            title="Delete entry"
                            description="Are you sure you want to delete this entry?"
                            onConfirm={() => {
                                deleteMutation.mutate({
                                    collection: "qdb_calendar_entries",
                                    id: entry_id,
                                });
                            }}
                            okText="Yes"
                            cancelText="No"
                            okButtonProps={{ danger: true }}
                        >
                            <Button danger icon={<DeleteOutlined />} loading={deleteMutation.isLoading}>Delete</Button>
                        </Popconfirm>
                    </div> : null}
                </div>
            }
            open_cp={open_cust}
            setOpenCp={setOpenCust}
        >
            <div
                style={{
                    position: "relative",
                    minHeight: "400px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {/* Tweet Display - Centered */}
                <div
                    style={{
                        position: "relative",
                        width: "100%",
                        maxWidth: "600px",
                    }}
                >
                    <Tweet content={tweets[currentTweetIndex]} />
                </div>

                {/* Navigation Arrows - Only show if multiple tweets */}
                {tweets.length > 1 && (
                    <>
                        <Button
                            type="text"
                            icon={<LeftOutlined />}
                            onClick={prevTweet}
                            disabled={currentTweetIndex === 0}
                            style={{
                                position: "absolute",
                                left: 10,
                                top: "50%",
                                transform: "translateY(-50%)",
                                zIndex: 1000,
                                height: "40px",
                                width: "40px",
                                borderRadius: "50%",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            }}
                        />
                        <Button
                            type="text"
                            icon={<RightOutlined />}
                            onClick={nextTweet}
                            disabled={currentTweetIndex === tweets.length - 1}
                            style={{
                                position: "absolute",
                                right: 10,
                                top: "50%",
                                transform: "translateY(-50%)",
                                zIndex: 1000,
                                height: "40px",
                                width: "40px",
                                borderRadius: "50%",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            }}
                        />
                    </>
                )}

                {/* Pagination Dots - Only show if multiple tweets */}
                {tweets.length > 1 && (
                    <div
                        style={{
                            position: "absolute",
                            bottom: -20,
                            left: "50%",
                            transform: "translateX(-50%)",
                            display: "flex",
                            justifyContent: "center",
                            gap: "8px",
                            paddingBottom: "10px",
                        }}
                    >
                        {tweets.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => goToTweet(index)}
                                style={{
                                    width: "12px",
                                    height: "12px",
                                    borderRadius: "50%",
                                    border: "none",
                                    backgroundColor:
                                        index === currentTweetIndex
                                            ? "#1890ff"
                                            : "#d9d9d9",
                                    cursor: "pointer",
                                    transition: "background-color 0.3s",
                                }}
                            />
                        ))}
                    </div>
                )}
            </div>

            {!isMobile && (
                <CanvasFeedbackBar
                    history_id={history_id}
                    entry_id={entry_id}
                />
            )}
        </QurealCanvasWrapper>
    );
}

export default QurealTweetPreview;
